import {
  CollaborativeDocumentFragment,
  CollaborativeDocumentQuery,
  CollaborativeDocumentQueryVariables,
  useCollaborativeDocumentQuery,
  useCollaborativeDocumentUpdatedSubscription,
  withStandardGetHook,
} from '@spotify/confidence-graphql';

const useCollaborativeDocumentImpl = withStandardGetHook<
  CollaborativeDocumentQuery,
  CollaborativeDocumentFragment,
  'collaborativeDocument',
  CollaborativeDocumentQueryVariables
>(useCollaborativeDocumentQuery, 'collaborativeDocument', {
  fetchPolicy: 'cache-first',
});

export const useCollaborativeDocument: typeof useCollaborativeDocumentImpl =
  options => {
    // Subscribe to collaborative document updates to get real-time AI generation progress
    useCollaborativeDocumentUpdatedSubscription({});

    return useCollaborativeDocumentImpl(options);
  };
